export const REPORTS_TABS = [
  {
    label: "Share Range Analysis",
    value: "share-range-analysis-events",
  },
  {
    label: "Location Analysis",
    value: "location-analysis-events",
  },
];

export const PROXY_EVENTS_TABS = [
  {
    label: "Voting",
    value: "voting",
  },
  {
    label: "Informational",
    value: "informational",
  },
  // {
  //   label: "Change Requests",
  //   value: "change-requests",
  // },
];

export const SHARE_RANGE_ANALYSIS_EVENT_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Reports",
    value: "reports",
  },
  {
    label: "Stats",
    value: "stats",
  },
];

export const LOCATION_ANALYSIS_EVENT_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Reports",
    value: "reports",
  },
  {
    label: "Stats",
    value: "stats",
  },
];

export const NOBO_EVENT_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Stats",
    value: "stats",
  },
];

export const PROXY_EVENT_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Materials",
    value: "materials",
  },
  {
    label: "Additional Mailings",
    value: "additional-mailings",
  },
  // { hiding additional mailing requests for now until completed
  //   label: "Additional Mailing Requests",
  //   value: "additional-mailing-requests",
  // },
  {
    label: "Voting",
    value: "voting",
  },
  {
    label: "Stats",
    value: "stats",
  },
  // {
  //   label: "Change Request",
  //   value: "change-request",
  // },
  {
    label: "Tabulation Reports",
    value: "tabulation-reports",
  },
];

export const ISSUER_TABS = [
  {
    label: "Proxy Events",
    value: "proxy-events",
  },
  {
    label: "Additional Mailings",
    value: "additional-mailings",
  },
  {
    label: "Bankruptcies",
    value: "bankruptcy-events",
  },
  {
    label: "Class Actions",
    value: "class-action-events",
  },
  {
    label: "Nobos",
    value: "nobo-events",
  },
  {
    label: "Reports",
    value: "reports",
  },
];

export const CLASS_ACTION_EVENT_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Materials",
    value: "materials",
  },
  {
    label: "Stats",
    value: "stats",
  },
];

export const BANKRUPTCY_EVENT_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Materials",
    value: "materials",
  },
  {
    label: "Stats",
    value: "stats",
  },
];

export const ADDITIONAL_MAILING_TABS = [
  {
    label: "Details",
    value: "details",
  },
  {
    label: "Materials",
    value: "materials",
  },
  {
    label: "Stats",
    value: "stats",
  },
];
